import React, { useState, useEffect } from "react";
import Icon from "../../../components/AppIcon";
import Button from "../../../components/ui/Button";
import Input from "../../../components/ui/Input";
import Select from "../../../components/ui/Select";

import { useDispatch } from "react-redux";
import {
  createClientService,
  getClientsService,
  updateClientService,
} from "redux/services/clients_service";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";

const CustomerModal = ({
  isOpen,
  onClose,
  customer,
  mode, // 'view', 'edit', 'create'
  onSave,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  // إضافة state داخلي للـ mode للسماح بالتبديل بين view و edit
  const [currentMode, setCurrentMode] = useState(mode);

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "", // تغيير من phone إلى phone_number ليتناسب مع API
    birthday: "",
    role_id: 3, // افتراضي للعميل
    is_verified: true,
    is_archived:false,
    password: "",
    password_confirmation: "",
  });

  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    setCurrentMode(mode); // تحديث currentMode عند تغيير mode من الأب
  }, [mode]);

  useEffect(() => {
    if (customer && (currentMode === "view" || currentMode === "edit")) {
      setFormData({
        first_name: customer.first_name || "",
        last_name: customer.last_name || "",
        phone_number: customer.phone_number || "", // تغيير من phone إلى phone_number
        birthday: customer.birthday || "",
        role_id: customer.role_id || 3,
        is_verified: true,
         is_archived:false,
        password: "", // لا تملأ كلمة المرور لأسباب أمنية
        password_confirmation: "",
      });
    } else if (currentMode === "create") {
      setFormData({
        first_name: "",
        last_name: "",
        phone_number: "", // تغيير من phone إلى phone_number
        birthday: "",
        role_id: 3,
        is_verified: true,
         is_archived:false,
        password: "",
        password_confirmation: "",
      });
    }
    setErrors({});
  }, [customer, currentMode, isOpen]);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));

    // مسح الخطأ عند الكتابة
    if (errors[field]) {
      setErrors((prev) => ({
        ...prev,
        [field]: "",
      }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.first_name.trim()) {
      newErrors.first_name = t("first_name_required"); // استخدم t() للترجمة
    }

    if (!formData.last_name.trim()) {
      newErrors.last_name = t("last_name_required");
    }

    if (!formData.phone_number.trim()) {
      newErrors.phone_number = t("phone_required");
    }

    if (!formData.birthday.trim()) {
      newErrors.birthday = t("birthday_required");
    }

    // كلمة المرور مطلوبة في الإنشاء، اختيارية في التحرير
    if (currentMode === "create" && !formData.password.trim()) {
      newErrors.password = t("password_required");
    }

    // إذا تم إدخال كلمة مرور، يجب أن تتطابق التأكيد
    if (formData.password.trim() && formData.password !== formData.password_confirmation) {
      newErrors.password_confirmation = t("password_mismatch");
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;

    setIsLoading(true);
    try {
      // إزالة onSave إذا لم يكن مطلوباً، أو تعديله حسب الحاجة
      // await onSave(formData);

      // إعداد البيانات للإرسال: إذا كانت كلمة المرور فارغة في التحرير، لا ترسلها
      const dataToSend = { ...formData };
      if (currentMode === "edit" && !formData.password.trim()) {
        delete dataToSend.password;
        delete dataToSend.password_confirmation;
      }

      if (currentMode === "create") {
      dispatch(createClientService(dataToSend))
  .then((response) => {
     if (response?.payload?.data?.success == true) {
           //  onUpdateOrder();
             onClose();
             toast("تمت عملية الإضافة   بنجاح");
             dispatch(getClientsService());
           } else {
             console.log("response?.payload");
             console.log(response?.payload?.response?.data?.errors);
             // تحسين عرض الأخطاء: جمعها في رسالة واحدة بدلاً من toast منفصل لكل خطأ
             let errorMessage = "";
             if (response?.payload?.response?.data?.errors) {
               // جمع كل الأخطاء في مصفوفة واحدة، ثم دمجها في string واحد
               const allErrors = Object.values(
                 response?.payload?.response?.data?.errors
               ).flatMap((errorArray) => errorArray); // مصفوفة من كل الرسائل
               errorMessage = allErrors.join("\n"); // فصل بسطر جديد (أو استخدم "، " لفصل بفاصلة)
             } else if (response?.payload?.message) {
               errorMessage = response.payload.message;
             } else {
               errorMessage = "حدث خطأ غير معروف";
             }
             // عرض الرسالة كـ toast واحد
             toast.error(errorMessage);
           }
  })
  .catch((error) => {
    // التعامل مع أخطاء الشبكة أو غيرها
    toast.error("حدث خطأ في الشبكة. حاول مرة أخرى.");
    console.error("Error:", error);
  });
      } else {
        dispatch(
          updateClientService({ id: customer?.enc_id, formData: dataToSend })
        ).then((response) => {
             if (response?.payload?.data?.success == true) {
           //  onUpdateOrder();
             onClose();
             toast("تم  التعديل بنجاح");
             dispatch(getClientsService());
           } else {
             console.log("response?.payload");
             console.log(response?.payload?.response?.data?.errors);
             // تحسين عرض الأخطاء: جمعها في رسالة واحدة بدلاً من toast منفصل لكل خطأ
             let errorMessage = "";
             if (response?.payload?.response?.data?.errors) {
               // جمع كل الأخطاء في مصفوفة واحدة، ثم دمجها في string واحد
               const allErrors = Object.values(
                 response?.payload?.response?.data?.errors
               ).flatMap((errorArray) => errorArray); // مصفوفة من كل الرسائل
               errorMessage = allErrors.join("\n"); // فصل بسطر جديد (أو استخدم "، " لفصل بفاصلة)
             } else if (response?.payload?.message) {
               errorMessage = response.payload.message;
             } else {
               errorMessage = "حدث خطأ غير معروف";
             }
             // عرض الرسالة كـ toast واحد
             toast.error(errorMessage);
           }
        });
      }
    } catch (error) {
      console.error("Error saving customer:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const roleOptions = [
    { value: 1, label: t("admin") },
    { value: 2, label: t("agent") },
    { value: 3, label: t("customer") },
  ];

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-elevation-3 w-full max-w-2xl max-h-[90vh] overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between p-6 border-b border-border">
          <div className="flex items-center space-x-3 gap-2">
            <div className="w-10 h-10 bg-primary rounded-md flex items-center justify-center">
              <Icon
                name={
                  currentMode === "create"
                    ? "User Plus"
                    : currentMode === "edit"
                    ? "Edit"
                    : "User"
                }
                size={20}
                color="white"
              />
            </div>
            <div>
              <h2 className="text-xl font-semibold text-foreground">
                {currentMode === "create"
                  ? t("add_new_customer")
                  : currentMode === "edit"
                  ? t("edit_customer")
                  : t("customer_details")}
              </h2>
              {customer && currentMode !== "create" && (
                <p className="text-sm text-muted-foreground">
                  ID: {customer.id}
                </p>
              )}
            </div>
          </div>
          <button variant="ghost" size="icon" onClick={onClose}>
            <Icon name="X" size={20} />
          </button>
        </div>

        {/* Content */}
        <div className="p-6 overflow-y-auto max-h-[calc(90vh-140px)]">
          {currentMode === "view" ? (
            // View Mode
            <div className="space-y-6">
              {/* Basic Information */}
              <div>
                <h3 className="text-lg font-medium text-foreground mb-4">
                  {t("basic_information")}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("first_name")}
                    </label>
                    <p className="text-foreground font-medium">
                      {customer?.first_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("last_name")}
                    </label>
                    <p className="text-foreground font-medium">
                      {customer?.last_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("phone")}
                    </label>
                    <p className="text-foreground">{customer?.phone_number}</p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("birthday")}
                    </label>
                    <p className="text-foreground">
                      {customer?.birthday ? formatDate(customer.birthday) : "N/A"}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-muted-foreground">
                      {t("roleName")}
                    </label>
                    <p className="text-foreground">
                      {roleOptions.find((r) => r.value === customer?.role_id)?.label || "N/A"}
                    </p>
                  </div>
           
                </div>
              </div>

              {/* إضافة أقسام أخرى إذا لزم الأمر، مثل Address و Notes */}
            </div>
          ) : (
            // Edit/Create Mode
            <div className="space-y-6">
              {/* Basic Information */}
              <div>
                <h3 className="text-lg font-medium text-foreground mb-4">
                  {t("basic_information")}
                </h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <Input
                    label={t("first_name")}
                    type="text"
                    value={formData.first_name}
                    onChange={(e) =>
                      handleInputChange("first_name", e.target.value)
                    }
                    error={errors.first_name}
                    required
                    placeholder={t("enter_first_name")}
                  />

                  <Input
                    label={t("last_name")}
                    type="text"
                    value={formData.last_name}
                    onChange={(e) =>
                      handleInputChange("last_name", e.target.value)
                    }
                    error={errors.last_name}
                    required
                    placeholder={t("enter_last_name")}
                  />

                  <Input
                    label={t("phone")}
                    type="tel"
                    value={formData.phone_number}
                    onChange={(e) => handleInputChange("phone_number", e.target.value)}
                    error={errors.phone_number}
                    required
                    placeholder={t("enter_phone_number")}
                  />

                  <Input
                    label={t("birthday")}
                    type="date"
                    value={formData.birthday}
                    onChange={(e) => handleInputChange("birthday", e.target.value)}
                    error={errors.birthday}
                    required
                  />

                  <Select
                    label={t("roleName")}
                    value={formData.role_id}
                    onChange={(value) => handleInputChange("role_id", value)}
                    options={roleOptions}
                    required
                  />

             

                  {/* كلمة المرور وتأكيدها في الإنشاء والتحرير */}
                  <Input
                    label={t("password")}
                    type="password"
                    value={formData.password}
                    onChange={(e) =>
                      handleInputChange("password", e.target.value)
                    }
                    error={errors.password}
                    required={currentMode === "create"} // مطلوبة في الإنشاء فقط
                    placeholder={t("enter_password")}
                  />

                  <Input
                    label={t("password_confirmation")}
                    type="password"
                    value={formData.password_confirmation}
                    onChange={(e) =>
                      handleInputChange("password_confirmation", e.target.value)
                    }
                    error={errors.password_confirmation}
                    required={currentMode === "create"} // مطلوبة في الإنشاء فقط
                 placeholder={t("confirm_password")}
                  />
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        <div className="flex items-center justify-end space-x-3 p-6 border-t border-border gap-6">
          {currentMode === "view" && (
            <Button
              variant="default"
              onClick={() => setCurrentMode("edit")} // التبديل إلى وضع التحرير
            >
              <Icon name="Edit" size={16} className="mr-2" />
              {t("edit_customer")}
            </Button>
          )}

          {(currentMode === "edit" || currentMode === "create") && (
            <Button variant="default" onClick={handleSave} loading={isLoading}>
              {currentMode === "create" ? t("addCustomer") : t("save")}
            </Button>
          )}

          <button variant="outline" onClick={onClose}>
            {currentMode === "view" ? t("close") : t("cancel")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CustomerModal;